import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import { Form, FormListFieldData } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import style from "./FormCollapseHeader.module.scss";

export interface IFormCollapseHeaderProsp {
  fields: FormListFieldData[];
  i: number;
  label?: string;
  canDelete?: boolean;
  add: (index?: number) => void;
  remove: (index: number) => void;
}

export const FormCollapseHeader: FC<IFormCollapseHeaderProsp> = ({
  i,
  fields,
  add,
  remove,
  label,
  canDelete = true,
}) => {
  const { t } = useTranslation();
  return (
    <div className={style.collapseHeader}>
      <div>
        {label || t("EVIDENCIJA_MARKICA.GRUPA_MARKICA_BROJ", { broj: i + 1 })}
      </div>
      <div>
        {i === fields.length - 1 && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              add();
            }}
          >
            <PlusCircleTwoTone />
          </div>
        )}
        {i !== fields.length - 1 && canDelete && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              remove(i);
            }}
          >
            <MinusCircleTwoTone twoToneColor={"red"} />
          </div>
        )}
      </div>
    </div>
  );
};
